document.addEventListener('DOMContentLoaded', () => {
    class ExternalLinks {
        constructor() {
            let anchors = [].slice.call(document.querySelectorAll('a[href]'));
            this.exeptionCases = ['storymaps.arcgis.com', 'storymapsdev.arcgis.com', 'storymapsstg.arcgis.com', 'uat', 'dev'];

            if (anchors && anchors.length) {
                anchors.forEach((a) => {
                    if (this.isExternal(a) && !a.hasAttribute('target')) {
                        a.setAttribute('target', '_blank');
                        a.setAttribute('rel', 'noopener');
                        a.setAttribute('aria-describedby', 'new-window');
                    }
                });
            }
        }

        isExternal(a) {
            let external = false;
            let href = a.getAttribute('href');
            href = href.toLowerCase();

            if (window.hasOwnProperty('isMultisite') && isMultisite) {
                return false;
            }

            if (href.indexOf('.pdf') > -1) { 
                external = true;
            }
            if (href.indexOf('//') > -1) {
                if (href.indexOf('esri.com') < 0 || (href.indexOf('.esri.com') > -1 && href.indexOf('www') < 0)) {
                    external = true;

                    // External Exceptions
                    this.exeptionCases.forEach(exptCase => {
                        let regexCase = RegExp(exptCase);

                        if (regexCase.test(href)) {
                            external = false;
                        }
                    })

                }
            }
            return external;
        }
    }

    new ExternalLinks();
});